import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './ListItem';
import { Plans } from '../../constants';
import './styles.scss';

const PerksList = ({ membership, showAdditionalPerks, getCouponContentKey }) => {
  const perks = getCouponContentKey(showAdditionalPerks ? 'additionalPerks' : 'perks', []);
  const planKey = membership === Plans.SEASONAL ? 'seasonal' : 'annual';
  const currentList = perks.filter((perk) => !perk.skip[planKey]);
  return (
    <div className="perks-list-container">
      <ul className="reactivate-perks-list">
        {currentList.filter((perk) => (perk.col === '1'))
          .map(({ label, check }) => (
            <ListItem key={label} label={label} check={check[planKey]} />
          ))}
      </ul>
      <ul className="reactivate-perks-list">
        {currentList.filter((perk) => (perk.col === '2'))
          .map(({ label, check }) => (
            <ListItem key={label} label={label} check={check[planKey]} />
          ))}
      </ul>
    </div>
  );
};

PerksList.defaultProps = {
  membership: '',
  showAdditionalPerks: false,
};

PerksList.propTypes = {
  membership: PropTypes.string,
  showAdditionalPerks: PropTypes.bool,
};

PerksList.displayName = 'PerksList';

export default PerksList;
